import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { RegionDeliveryRangeSettingEntity } from '../../domain/entities/RegionDeliveryRangeSettingEntity'
import type { RegionDeliveryRangeSettingAdminDto } from '@/backend/market'

export class RegionDeliveryRangeSettingModel extends RegionDeliveryRangeSettingEntity {
  constructor(dataDto: RegionDeliveryRangeSettingAdminDto) {
    super()
    mapEntityProperties<RegionDeliveryRangeSettingEntity>(this, dataDto, {
      map: {
        region: {
          id: dataDto.regionId,
          name: dataDto.regionName
        }
      }
    })
  }
}
